const _excluded = ["legalDisclaimer", "color", "foregroundInlineLink"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import './Div/index.js';
import './RichText/index.js';
import { disclaimerRichTextOptions } from './RichText/options/disclaimerRichTextOptions.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from './Div/Div.js';
import { RichText } from './RichText/RichText.js';
function LegalDisclaimer(_ref) {
  let legalDisclaimer = _ref.legalDisclaimer,
    color = _ref.color,
    foregroundInlineLink = _ref.foregroundInlineLink,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Div, _objectSpread(_objectSpread({
    flexDirection: "column",
    alignItems: "center"
  }, rest), {}, {
    children: /*#__PURE__*/jsx(Div, {
      flexDirection: "column",
      children: /*#__PURE__*/jsx(RichText, {
        content: legalDisclaimer,
        richTextOptions: disclaimerRichTextOptions,
        color: color,
        secondaryColor: color,
        paragraphSpacingTop: 2,
        foregroundInlineLink: foregroundInlineLink
      })
    })
  }));
}
export { LegalDisclaimer };
//# sourceMappingURL=LegalDisclaimer.js.map
